import { createDate, importAll, transformImages } from "utils";

import AcceptanceLetterMain from "../../_hp-acceptance-letter-main";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <ReplicaQuote source="Harry Potter and the Philosopher's Stone">
        They ate stale cornflakes and cold tinned tomatoes on toast for
        breakfast next day. They had just finished when the owner of the hotel
        came over to their table. ‘ ’Scuse me, but is one of you Mr H. Potter?
        Only I got about an ’undred of these at the front desk.’ She held up a
        letter so they could read the green ink address: Mr H. Potter, Room 17,
        Railview Hotel, Cokeworth. Harry made a grab for the letter but Uncle
        Vernon knocked his hand out of the way.
      </ReplicaQuote>

      <ReplicaParagraph>
        A fully readable, authentic replica of Harry Potter’s third Hogwarts
        acceptance letter. In the book, Harry receives this letter at a hotel
        where he and the Dursleys are staying after Uncle Vernon, in a desperate
        attempt to escape the barrage of Hogwarts letters, decides to flee.
        Since this third letter never appeared in the films, I designed it
        entirely from scratch, using Harry’s first letter as a reference.
      </ReplicaParagraph>

      <AcceptanceLetterMain gallery={transformImages(gallery)} />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
